{
	"title": "Dostępne materiały",
	"showAllTitle": "Pokaż wszystkie materiały",
	"table": {
		"material": "Materiał",
		"invoicedQuantity": "Ilość zafakturowana",
		"remainingForTransfer": "Pozostało do utworzenia deklaracji",
		"fetchError": "Nie udało się pobrać materiałów",
		"noMaterials": {
			"title": "Brak dostępnych materiałów",
			"description": "Obecnie nie masz dostępnych materiałów w {{productName}}. Skontaktuj się ze swoim przedstawicielem handlowym, aby dodać umowę(-y) do Twojego konta."
		}
	}
}
